const numeralEndings = {
  1: 'st',
  2: 'nd',
  3: 'rd',
  4: 'th',
};

export default numeralEndings;
